"use client";
import * as RadixAlertDialog from "@radix-ui/react-alert-dialog";
import Icon from "./icon";
import Button from "./button";

export interface AlertDialogProps {
  trigger: React.ReactNode;
  danger?: boolean;
  title: string;
  message: string;
  action: ActionProps;
}

function AlertDialog(props: AlertDialogProps) {
  return (
    <>
      <RadixAlertDialog.Root>
        <RadixAlertDialog.Trigger asChild>
        {props.trigger}
        </RadixAlertDialog.Trigger>
        <RadixAlertDialog.Portal>
          <RadixAlertDialog.Overlay className="bg-white/75 data-[state=open]:animate-overlayShow fixed inset-0 backdrop-blur-sm z-[49]" />
          <RadixAlertDialog.Content className={`z-50 rounded-xl flex flex-col overflow-hidden bg-surface data-[state=open]:animate-contentShow fixed top-[50%] left-[50%] max-h-[85vh] w-[90vw] max-w-[450px] translate-x-[-50%] translate-y-[-50%] p-6 shadow-elevation-400 focus:outline-none`}>
            <div className="inline-flex">
              <Icon
                variant="circle"
                color="error"
                name="alert-triangle"
                className="p-6"
              />
            </div>
            <div className="my-4">
              <RadixAlertDialog.Title className="text-title-lg-bold uppercase text-dark">
                {props.title}
              </RadixAlertDialog.Title>
              <RadixAlertDialog.Description className="mt-3 text-base text-secondary-200">
                {props.message}
              </RadixAlertDialog.Description>
            </div>
            <div className="flex justify-end gap-2">
              <RadixAlertDialog.Cancel asChild>
                <Button color="tertiary" ghost>
                  Back
                </Button>
              </RadixAlertDialog.Cancel>
              <RadixAlertDialog.Action>
                <Button
                  color={`${props.danger ? "error" : "primary"}`}
                  href={props.action.href}
                  onClick={props.action.onClick}
                >
                  {props.action.label}
                </Button>
              </RadixAlertDialog.Action>
            </div>
            <RadixAlertDialog.Cancel asChild>
              <Button variant="circle" color="tertiary" className="bg-transparent absolute top-4 right-4">

                <Icon name="close" size="sm" />
              </Button>
            </RadixAlertDialog.Cancel>
          </RadixAlertDialog.Content>
        </RadixAlertDialog.Portal>
      </RadixAlertDialog.Root>
    </>
  );
}

function Trigger(props: RadixAlertDialog.AlertDialogTriggerProps) {
  return (
    <RadixAlertDialog.Trigger {...props} asChild>
      {props.children}
    </RadixAlertDialog.Trigger>
  );
}

AlertDialog.Trigger = Trigger;
export default AlertDialog;
